import "../styles/css/admin-style.css";
import {useLocation, useParams} from "react-router-dom";
import {businessYearService} from "../services/businessYearService";
import AreaSchedulesCard from "../components/yearly-settings/AreaSchedulesCard";
import SeasonDatesCard from "../components/yearly-settings/SeasonDatesCard";
import PricePerSqFtCard from "../components/yearly-settings/PricePerSqFtCard";
import MaxDailyValueCard from "../components/yearly-settings/MaxDailyValueCard";
import PriceAdjustmentsCard from "../components/yearly-settings/PriceAdjustmentsCard";
import BlackoutDatesCard from "../components/yearly-settings/BlackoutDatesCard";
import {useEffect, useState} from "react";
import eventEmitter from "../shared/eventEmitter";
import {EventEmitterTypes} from "../shared/eventEmitterEnum";
import {usePageData} from "../shared/components/PageContext";

const YearlySettingDetailsPage = () => {
    const { year } = useParams();
    const { state } = useLocation();
    const getSettingFromYear = async () => {
        return await businessYearService.getBusinessYear(year);
    }
    const [settingDetails, setSettingDetails] = useState();
    const { setPageData } = usePageData();

    const refreshListener = () => {
        getSettingFromYear().then(res => {
            setSettingDetails(res)
            setPageData(res)
        });
    };

    useEffect(() => {
        

        eventEmitter.on(EventEmitterTypes.REFRESH_YEARLY_SETTINGS, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_YEARLY_SETTINGS, refreshListener);
        };
    }, []);


    useEffect(() => {
        refreshListener()
    }, []);
    
    return (
        <>
        {settingDetails && (
            <div className="container-fluid ptCustom">
                <div className="row mt-2">
                    {/*<!-- LEFT -->*/}
                    <div className="col-lg-8">
                        <div className="row">
                            <div className="col-md-8">
                                <SeasonDatesCard details={settingDetails}/>
                            </div>
                            <div className="col-md-4">
                                <MaxDailyValueCard details={settingDetails}/>
                            </div>
                        </div>
                        <PricePerSqFtCard details={settingDetails}/>
                        <PriceAdjustmentsCard details={settingDetails}/>
                    </div>
                    {/*!--RIGHT--*/}
                    <div className="col-lg-4">
                        <AreaSchedulesCard details={settingDetails}/>
                        <BlackoutDatesCard details={settingDetails}/>
                    </div>
                </div>
            </div>
        )}
        </>
    );
};

export default YearlySettingDetailsPage;
